<div class="card mb-3">
    <div class="card-body" [formGroup]="formGroup">
        <div class="card-title">
            <h5>{{ 'titles_Readings' | translate: 'online' : 'systems' }}</h5>
        </div>
        <div class="row">
            <button
                type="button"
                class="col-md-3 col-sm-1 btn btn-link text-end"
                (click)="moveOneDayBack()">
                <i class="bi bi-chevron-left"></i>
            </button>
            <div class="col-md-6 col-sm-10">
                <app-input-date-group formControlName="date" [maxDate]="maxDate()" />
            </div>
            @if (allowMoveDateForward$ | async) {
                <button
                    type="button"
                    class="col-md-3 col-sm-1 btn btn-link text-start"
                    (click)="moveOneDayForward()">
                    <i class="bi bi-chevron-right"></i>
                </button>
            }
        </div>
        @if (view$ | async; as view) {
            <div class="table-responsive w-100">
                <table class="table table-striped table-sm">
                    <thead>
                        <tr>
                            <th>{{ 'properties_placement' | translate: 'online' : 'systems' }}</th>
                            @if (view.showSerialNo) {
                                <th>
                                    {{ 'properties_meterNo' | translate: 'online' : 'systems' }}
                                </th>
                            }
                            <th>{{ 'properties_usage' | translate: 'online' : 'systems' }}</th>
                            @if (deviceDetailsEnabled()) {
                                <th class="text-nowrap">
                                    {{
                                        'properties_reading_method'
                                            | translate: 'online' : 'systems'
                                    }}
                                </th>
                            }
                            <th>{{ 'titles_Latest_reading' | translate: 'online' : 'systems' }}</th>
                            <th>{{ 'titles_meter_value' | translate: 'online' : 'systems' }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (reading of view.readings; track reading) {
                            <tr>
                                <td>{{ reading.meter.placement }}</td>
                                @if (view.showSerialNo) {
                                    <td>{{ reading.meter.meterNo }}</td>
                                }
                                <td>
                                    {{
                                        'mappers_allocationUnitMap.' + reading.meter.allocationUnit
                                            | translate: 'online' : 'common'
                                    }}
                                </td>
                                @if (deviceDetailsEnabled()) {
                                    <td>{{ reading.meterValue.readingMethod }}</td>
                                }
                                <td>{{ reading.meterValue.readingDate | appdatetime }}</td>
                                <td class="text-end text-nowrap">
                                    {{ reading.meterValue.value | appnumber }}
                                    {{
                                        'mappers_measurementUnit.' + reading.meterValue.unit
                                            | translate: 'online' : 'common'
                                    }}
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
    </div>
</div>
